import { render, staticRenderFns } from "./CreateForumGroup.vue?vue&type=template&id=50ba6672&scoped=true&"
import script from "./CreateForumGroup.vue?vue&type=script&lang=js&"
export * from "./CreateForumGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ba6672",
  null
  
)

export default component.exports